import { createContext, useContext } from 'react';
export const MediaZoomContext = createContext(undefined);
export const useMediaZoomContext = () => {
    const context = useContext(MediaZoomContext);
    if (context === undefined) {
        throw new Error('useMediaZoom must be used within a MediaZoomProvider');
    }
    return context;
};
//# sourceMappingURL=MediaZoomContext.js.map